/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BasePurchase } from './BasePurchase';
import { CoursePrice } from './CoursePrice';
const CoursePurchaseParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['scope', /* #__PURE__ */ parsers.exactly('course')],
    ['purchasedItem', CoursePrice, 'purchased_item'],
]), BasePurchase);
export class CoursePurchase extends BasePurchase {
    static decode(input) {
        return CoursePurchaseParser.decode(input).map(res => new CoursePurchase(res));
    }
    static unsafeDecode(input) {
        return CoursePurchase.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CoursePurchaseParser.encode(data);
    }
    static schema() {
        return CoursePurchaseParser.schema();
    }
}
